import React from 'react'
import { Header, Icon } from 'semantic-ui-react'

const HeaderExampleImage = (prop) => (
  <Header inverted>
    <Icon name={prop.isBot?'usb':'user'} /> {prop.username}
  </Header>
)

export default HeaderExampleImage